<template>
    <div class="billing-plans">
        <div
            v-for="(name, interval) in intervals"
            :key="interval"
            class="plan-wrapper"
        >
            <div
                :class="['plan', { disabled, active: value === interval }]"
                @click="changeInterval(interval)"
            >
                <div class="plan-container flex">
                    <div class="plan-icon">
                        <svg-vue class="check" icon="check" />
                    </div>
                    <div class="plan-credentials">
                        <div class="plan-name">
                            {{ name }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    model: {
        event: 'change',
        prop: 'value',
    },

    props: {
        intervals: {
            required: true,
            type: Object,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        value: {
            type: String,
            default: null,
        },
    },

    methods: {
        /**
         * Changes selected interval.
         *
         * @param  {string} interval Selected interval.
         */
        changeInterval(interval) {
            if (this.disabled || interval === this.value) {
                return;
            }

            this.$emit('change', interval);
        },
    },
};
</script>
